import { clientFor } from '@yc/api-client'

const api = clientFor('/scr/api')

/** 工作台 KPI：与后端 internal/home/service.go 的 Stats 的 JSON 字段一一对应 */
export interface HomeStats {
  /** 待处理预警数（critical + warn 且 open / processing） */
  open_alerts: number
  /** 其中 critical 级 */
  critical_alerts: number
  /** 其中 warn 级 */
  warn_alerts: number
  /** 待执行响应数（status = pending） */
  pending_responses: number
  /** 新建需求数（status = new） */
  new_demands: number
}

export const getHomeStats = (): Promise<HomeStats> => api.get<HomeStats>('/home/stats')
